import { render } from "./CounterwiseQuota.vue?vue&type=template&id=69dddd35&scoped=true"
import script from "./CounterwiseQuota.vue?vue&type=script&lang=js"
export * from "./CounterwiseQuota.vue?vue&type=script&lang=js"

import "./CounterwiseQuota.vue?vue&type=style&index=0&id=69dddd35&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dddd35"]])

export default __exports__